import { GetBy } from '../core/Element';
import { gsap } from 'gsap';

export default class _Wrap {
  static mainholder = GetBy.id("Main");
  static options = {
    show: {
      duration: .5,
      delay: 1,
      ease: ""
    },
    hide: {
      duration: .5,
      delay: 0,
      ease: ""
    }
  }

  static show(__call, opts = {}) {
    const delay = opts.delay || this.options.show.delay;

    gsap.set(this.mainholder, { y: '10vh' });
    gsap.to(this.mainholder, {
      y: 0,
      duration: .6,
      delay,
      ease: opts.ease || this.options.show.ease,
      onComplete: () => {
        if (__call) __call();
      }
    });
    gsap.to(this.mainholder, {
      alpha: 1,
      duration: .3,
      delay: delay + .1,
      ease: opts.ease || this.options.show.ease
    });
  }

  static hide(__call, opts = {}) {
    gsap.set(this.mainholder, { y: 0 });
    gsap.to(this.mainholder, {
      y: '-30vh',
      duration: .5,
      delay: opts.delay || this.options.hide.delay,
      ease: opts.ease || this.options.hide.ease,
      onComplete: () => {
        if (__call) __call();
      }
    });
    gsap.to(this.mainholder, {
      alpha: 0,
      duration: .3,
      ease: opts.ease || this.options.hide.ease
    });
  }

  static directShow() {
    this.mainholder.style.opacity = "1";
  }

  static directHide() {
    this.mainholder.style.opacity = "0";
  }
}
